import {DefaultTheme} from '@react-navigation/native';

export const blackNavigationTheme = {
  ...DefaultTheme,
  colors: {...DefaultTheme.colors, background: '#000'}
};
